import { toast } from 'sonner';
import { useNavigate } from 'react-router-dom';
import { APP_ROUTES } from '@/utils/appRoutes';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { useCallback } from 'react';

export function useShowMessageNotification() {
  const navigate = useNavigate();

  const showMessageNotification = useCallback(
    ({
      senderName,
      messageContent,
      chatId,
      avatarUrl,
    }: {
      senderName: string;
      messageContent: string;
      chatId: string;
      avatarUrl?: string;
    }) => {
      toast.custom(
        (t) => (
          <div
            onClick={() => {
              toast.dismiss(t);
              navigate(`${APP_ROUTES.MESSAGES}/${chatId}`);
            }}
            className="flex flex-col w-full bg-violet-500 rounded-xl shadow-md  cursor-pointer select-none transition hover:bg-violet-200"
          >
            <div className="flex justify-between items-center text-xs text-white-500 text-white p-3">
              <span>Nuovo messaggio!</span>
              <span>Adesso</span>
            </div>
            <div className="flex w-full bg-violet-200 p-3 items-center gap-x-2">
              <Avatar className="h-12 w-12">
                <AvatarImage src={avatarUrl} />
                <AvatarFallback>{senderName[0]}</AvatarFallback>
              </Avatar>
              <div className="flex flex-col">
                <div className="text-sm text-black font-semibold leading-tight">
                  {senderName}
                </div>
                <div className="text-sm text-gray-700 leading-snug">
                  {messageContent.length > 100
                    ? messageContent.slice(0, 100) + '...'
                    : messageContent}
                </div>
              </div>
            </div>
          </div>
        ),
        {
          position: 'top-center',
          duration: 8000,
        },
      );
    },
    [navigate],
  );

  return showMessageNotification;
}
